import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { GlobalVariable } from "app/global/global";
import { ObraSocial } from "app/models/obraSocial.interface";
import { Medicamento } from "app/models/medicamento.interface";

@Injectable({
  providedIn: "root",
})
export class CatalogoRecetarioService {
  private readonly url = `${GlobalVariable.BASE_API_URL}api/recetario/`;

  constructor(private http: HttpClient) {}

  getObrasSociales(): Observable<ObraSocial[]> {
    return this.http.get<ObraSocial[]>(`${this.url}obras-sociales`);
  }

  searchMedicamentos(search: string): Observable<Medicamento[]> {
    if (!search || search.trim().length < 3) {
      return of([]);
    }
    return this.http.get<Medicamento[]>(`${this.url}medicamentos`, {
      params: { search: search.trim() },
    });
  }
}
